import CarePlanScreen from './CarePlanScreen/CarePlanScreen';
import * as carePlanService from './carePlanService';

export default CarePlanScreen;
export { carePlanService };
